<template>
  <div>
    <slot />
  </div>
</template>

<script>
import Slideout from 'slideout'

export default {
  name: 'Slideout',
  props: {
    panel: {
      type: String,
      default: '#panel',
    },
    menu: {
      type: String,
      default: '#menu',
    },
    padding: {
      type: Number,
      default: 256,
    },
    tolerance: {
      type: Number,
      default: 70,
    },
    touch: {
      type: Boolean,
      default: true,
    },
    easing: {
      type: String,
      default: 'ease',
    },
    side: {
      type: String,
      default: 'left',
    },
    duration: {
      type: Number,
      default: 300,
    },
    selectors: {
      type: Array,
      default: function () {
        return []
      },
    },
  },
  data() {
    return {
      slideout: null,
    }
  },
  mounted: function () {
    this.slideout = new Slideout({
      panel: document.querySelector(this.panel),
      menu: document.querySelector(this.menu),
      padding: this.padding,
      tolerance: this.tolerance,
      touch: this.touch,
      easing: this.easing,
      side: this.side,
      duration: this.duration,
    })
    this.selectors.forEach((selector) => {
      document.querySelector(selector).addEventListener('click', () => {
        this.slideout.toggle()
      })
    })
    const events = [
      'beforeclose',
      'close',
      'beforeopen',
      'open',
      'translatestart',
      'translate',
      'translateend',
    ]
    events.forEach((event) => {
      this.slideout.on(event, () => {
        this.$emit('on-' + event, event)
      })
      this.slideout.once(event, () => {
        this.$emit('once-' + event, event)
      })
    })

    const checkOpen = (eve) => {
      if (this.slideout.isOpen()) {
        eve.preventDefault()
        this.slideout.close()
      }
    }

    const menuUsuario = document.querySelector('#menuUsuario')

    const addClick = () => {
      this.slideout.panel.addEventListener('click', checkOpen)

      if (menuUsuario) {
        menuUsuario.addEventListener('click', checkOpen)
      }
    }

    const removeClick = () => {
      this.slideout.panel.removeEventListener('click', checkOpen)

      if (menuUsuario) {
        menuUsuario.removeEventListener('click', checkOpen)
      }
    }

    this.slideout.on('open', addClick)
    this.slideout.on('close', removeClick)
  },
}
</script>
